import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, CanMatchFn } from '@angular/router';
import { AuthSessionService } from '../services/auth-session.service';

export const authGuard: CanActivateFn = (route, state) => {
  return inject(AuthSessionService).ensureAuthenticated();
};

export const authGuardChild: CanActivateChildFn = (route, state) => {
  return inject(AuthSessionService).ensureAuthenticated();
};

export const authMatchGuard: CanMatchFn = (route, segments) => {
  return inject(AuthSessionService).ensureAuthenticated();
};
